import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useFoodflowSessionStore = defineStore('foodflowSession', () => {
    const all = ref(null);

    const reset = () => {
        all.value = null;
    };

    const actions = {
        search: (params) => axios.get('/api/v1/foodflow-sessions', { params }),
        show: (hash) => axios.get('/api/v1/foodflow-sessions/' + hash),
        storeSession: (params) => axios.post('/api/v1/foodflow-sessions', params),
        addEntry: (sessionHash, params) => axios.post('/api/v1/foodflow-sessions/' + sessionHash + '/entries', params),
        removeEntry: (sessionHash, entryHash) => axios.delete('/api/v1/foodflow-sessions/' + sessionHash + '/entries/' + entryHash),
    };

    return {
        all,
        reset,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useFoodflowSessionStore.acceptHMRUpdate);
}
